import { Paginator as PrimePaginator } from "primereact/paginator";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function usePaginator() {

    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ page, setPage ] = useState(Number(searchParams.get('page')) || 0);
    const [ limit, setLimit ] = useState(Number(searchParams.get('limit')) || 10);
    const [ total, setTotal ] = useState(0);

    const pageChange = (e) => {
        setPage(e.page);
        setLimit(e.rows);
    };

    const Paginator = () => (
        <PrimePaginator
            first={limit * page} 
            rows={limit} 
            totalRecords={total} 
            rowsPerPageOptions={[10, 20, 30]} 
            onPageChange={pageChange}/>
    );

    return { page, limit, total, setTotal, setPage, Paginator };
}